import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.shopUrls = {
            'dev': 'https://shopadmin-dev.zuowenzhitiao.com/',
            'test': 'https://shopadmin-test.zuowenzhitiao.com/',
            'grey': 'https://zwzt-shopadmin-gray.zuowenzhitiao.com/',
            'online': 'https://zwzt-shopadmin.zuowenzhitiao.com/'
        };
        this.workUrls = {
            'dev': 'https://composition-dev.zuowenzhitiao.com/',
            'test': 'https://composition-test.zuowenzhitiao.com/',
            'grey': 'https://composition-admin-gray.zuowenzhitiao.com/',
            'online': 'https://composition-admin.zuowenzhitiao.com/'
        };
    }
    onJump(type) {
        const COURSE_ADMIN_ENV = process.env.COURSE_ADMIN_ENV;
        console.log(COURSE_ADMIN_ENV);
        if (type == 'work') {
            let url = this.workUrls[COURSE_ADMIN_ENV || 'online'];
            window.open(url);
        }
        else if (type == 'shop') {
            let url = this.shopUrls[COURSE_ADMIN_ENV || 'online'];
            window.open(url);
        }
    }
};
Login = tslib_1.__decorate([
    Component
], Login);
export default Login;
